import React from "react";

const SkeletonWishList: React.FC = () => {
  return (
    <div>
      {[1, 2, 3, 4, 5].map((item) => (
        <div key={item}>
          <div className="flex items-center justify-between mb-3 max-lg:hidden">
            <div className="grid grid-cols-[130px_1fr_160px] max-lg:grid-cols-[90px_1fr_30px] max-sm:grid-cols-[70px_1fr_30px] items-center gap-3 max-lg:gap-2 w-full">
              <div className="w-full h-44 max-md:h-20 object-cover rounded-lg max-md:rounded-md skeleton" />
              <div className="overflow-hidden max-md:flex-col max-sm:justify-between max-sm:items-center">
                <div className="flex justify-start items-center gap-4 max-md:flex-col">
                  <div className="mb-4 max-sm:mb-0 truncate break-words block skeleton h-8 max-md:h-5 max-md:rounded-md w-10"></div>
                  <div className="mb-4 max-sm:mb-0 truncate break-words block skeleton h-8 max-md:h-5 max-md:rounded-md w-20 max-md:hidden"></div>
                </div>
                <div className="skeleton h-8 max-md:h-5 max-md:rounded-md w-80"></div>
                <div className="flex items-center gap-1 duration-150 skeleton h-8 max-md:h-5 max-md:rounded-md w-28 mt-2"></div>
              </div>
              <div className="flex min-w-[159px] justify-center mt-4 rounded-3xl bg-no-repeat bg-cover bg-center py-4 px-9 duration-150 skeleton h-12 w-28"></div>
            </div>
          </div>
          <div className="items-center justify-between relative max-md:p-4 max-sm:p-2 max-md:border max-md:border-[#89D9EE] max-md:rounded-xl mb-2 hidden max-lg:flex">
            <div className="grid grid-cols-[130px_1fr_160px] max-lg:grid-cols-[90px_1fr_30px] max-sm:grid-cols-[70px_1fr_30px] items-center gap-3 max-lg:gap-2 w-full">
              <div className="w-full h-44 max-lg:h-32 max-sm:h-16 relative">
                <div className="skeleton size-full !rounded-lg absolute"></div>
              </div>
              <div className="flex flex-col gap-1 w-full">
                <div className="skeleton w-20 h-4 !rounded"></div>
                <div className="skeleton w-40 h-4 !rounded"></div>
                <div className="skeleton w-28 h-4 !rounded"></div>
              </div>
              <div className="flex flex-col justify-end items-end gap-2">
                <div className="skeleton w-7 h-7 !rounded"></div>
                <div className="skeleton w-7 h-7 !rounded"></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkeletonWishList;
